package com.anjuros.website.templates.template9.util

import com.anjuros.website.components.shared.CompanyDetailsType
import com.anjuros.website.components.shared.DetailsType
import com.anjuros.website.templates.template9.util.Template9Constants.CLIENTS_COMPANY
import com.anjuros.website.templates.template9.util.Template9Constants.CLIENTS_EMAIL
import com.anjuros.website.templates.template9.util.Template9Constants.CLIENTS_FACEBOOK_NAME
import com.anjuros.website.templates.template9.util.Template9Constants.CLIENTS_INSTAGRAM_NAME
import com.anjuros.website.templates.template9.util.Template9Constants.CLIENTS_NAME
import com.anjuros.website.templates.template9.util.Template9Constants.CLIENTS_PHONE
import com.anjuros.website.templates.template9.util.Template9Constants.CLIENTS_SERVICE_AREA

enum class Template9CompanyDetails : CompanyDetailsType {
    CLIENTS_COMPANY_INFO {
        override fun value(): String = CLIENTS_COMPANY
        override fun getType(): DetailsType = DetailsType.COMPANY
    },
    CLIENTS_NAME_INFO {
        override fun value(): String = CLIENTS_NAME
        override fun getType(): DetailsType = DetailsType.COMPANY_NAME
    },
    CLIENTS_EMAIL_INFO {
        override fun value(): String = CLIENTS_EMAIL
        override fun getType(): DetailsType = DetailsType.EMAIL
    },
    CLIENTS_PHONE_INFO {
        override fun value(): String = CLIENTS_PHONE
        override fun getType(): DetailsType = DetailsType.COMPANY_PHONE
    },
    CLIENTS_SERVICE_AREA_INFO {
        override fun value(): String = CLIENTS_SERVICE_AREA
        override fun getType(): DetailsType = DetailsType.COMPANY_SERVICE_AREA
    },
    CLIENTS_FACEBOOK_INFO {
        override fun value(): String = CLIENTS_FACEBOOK_NAME
        override fun getType(): DetailsType = DetailsType.COMPANY_FACEBOOK
    },
    CLIENTS_INSTAGRAM_INFO {
        override fun value(): String = CLIENTS_INSTAGRAM_NAME
        override fun getType(): DetailsType = DetailsType.COMPANY_INSTAGRAM
    },
}
